import React, { useEffect, useContext } from "react";
import { withRouter, Redirect } from "react-router-dom";
import jwt_decode from "jwt-decode";
import AppContext from "../context/Context";
import authenticationService from "../services/authenticationService";

// const parseJwt = (token) => {
//   try {
//     return JSON.parse(atob(token.split(".")[1]));
//   } catch (e) {
//     return null;
//   }
// };

const AuthVerify = ({ history, refreshTokenExpired, setRefreshTokenExpired }) => {
  const { loginUserDetails, accessToken } = useContext(AppContext);

  // useEffect(() => {
  // const user = localStorage.getItem("usr");
  // if (refreshTokenExpired) {
  //   if (user && Object.keys(loginUserDetails).length === 0) {
  //     localStorage.removeItem("usr");
  //     setRefreshTokenExpired(false);
  //     history.push("/v4/portal/authentication/login");
  //   }
  // }
  return <></>;
};

export default withRouter(AuthVerify);
